export default __webpack_public_path__ + "static/153-min-min-c3d9bc37e728cdb1ac30514a9c4cc311.jpg";